export default __webpack_public_path__ + "static/media/logo.36710f10.png";